import { User } from 'firebase/auth'
import { Link } from 'react-router-dom'

interface NavbarProps {
  user: User
  onLogout: () => Promise<void>
}

const Navbar = ({ user, onLogout }: NavbarProps) => {
  return (
    <nav className="bg-white shadow">
      <div className="w-full px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-16">
          <div className="flex">
            <div className="flex-shrink-0 flex items-center">
              <Link to="/dashboard" className="text-xl font-bold text-gray-900">
                Auth Service
              </Link>
            </div>
            <div className="hidden sm:ml-6 sm:flex sm:space-x-8">
              <Link
                to="/dashboard"
                className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200"
              >
                Dashboard
              </Link>
              <Link
                to="/roles"
                className="border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium transition-colors duration-200"
              >
                Role Management
              </Link>
            </div>
          </div>
          <div className="flex items-center">
            <div className="hidden sm:flex items-center space-x-4">
              <div className="flex items-center">
                <img
                  className="h-8 w-8 rounded-full"
                  src={user.photoURL || undefined}
                  alt={user.displayName || 'User'}
                />
                <span className="ml-2 text-sm text-gray-700">{user.displayName}</span>
              </div>
              <button
                onClick={onLogout}
                className="bg-red-600 hover:bg-red-700 text-white px-3 py-1 rounded-md text-sm font-medium transition-colors duration-200"
              >
                Logout
              </button>
            </div>
            {/* Mobile menu button */}
            <div className="sm:hidden ml-3">
              <div className="flex items-center space-x-2">
                <img
                  className="h-8 w-8 rounded-full"
                  src={user.photoURL || undefined}
                  alt={user.displayName || 'User'}
                />
                <button
                  onClick={onLogout}
                  className="bg-red-600 hover:bg-red-700 text-white px-2 py-1 rounded text-xs font-medium transition-colors duration-200"
                >
                  Logout
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default Navbar 